import React, { useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import VerticalNav from "./VerticalNav";
import VerticalTabContent from "./VerticalTabContent";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { VerticalTabTitle } from "../../../../Constants/Constants";
import { VerticalTabSubTitle } from "../../../../Data/UiKits/Tabs";

const VerticalTab = () => {
  const [basicTab, setBasicTab] = useState("2");
  return (
    <Col sm="12" xxl="6">
      <Card className="height-equal">
        <CommonCardHeader title={VerticalTabTitle} span={VerticalTabSubTitle} />
        <CardBody>
          <Row>
            <Col md="4" xs="12">
              <VerticalNav basicTab={basicTab} setBasicTab={setBasicTab} />
            </Col>
            <Col md="8" xs="12">
              <VerticalTabContent tabId={basicTab} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default VerticalTab;
